import PropTypes from 'prop-types';

import './WorkspacePanel.css';

import { buildClass } from '../../libs/classes';

/**
 * Workspace panel
 * @component
 */
export const WorkspacePanel = ({ className, children }) => {
	return <div className={buildClass('panel', className)}>{children}</div>;
};

WorkspacePanel.propTypes = {
	// Additional class for panel
	className: PropTypes.string,
	// Panel content
	children: PropTypes.node.isRequired,
};

/**
 * Head for workspace panel
 * @component
 */
export const WorkspacePanelHead = ({ title, className, children }) => {
	return (
		<div className={buildClass('head', className)}>
			<div className="title">{title}</div>
			<div className="spacer" />
			{children ? <div className="body">{children}</div> : null}
		</div>
	);
};

WorkspacePanelHead.propTypes = {
	// Title for panel head
	title: PropTypes.string.isRequired,
	// Additional class
	className: PropTypes.string,
	// Panel head body
	children: PropTypes.node,
};

export default WorkspacePanel;
